export default "__VITE_ASSET__FL5oMFdW__"